export const loanCalculatorData = [
  {
    id: 1,
    heading:
      "Credit Card EMI Calculator: Plan Your Monthly Payments Efficiently",
    subHeading:
      "Converting your credit card transactions into EMIs is a great way to manage large expenses without straining your monthly budget. With Minemi’s Credit Card EMI Calculator, you can estimate monthly payments, understand interest rates, and compare repayment options to make informed financial decisions.",

    notice:
      "Whether you’re managing large purchases, medical expenses, or consolidating credit card payments, Minemi’s tools and insights ensure you make the right financial decisions. Start calculating your credit card EMIs today and take control of your financial future!",
    updationText: "Updated Oct 14, 2024 ·",
    updateTime: "3 min read",
  },
];
